/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoFusionModelsRendererRect
 */
export interface MelcoFusionModelsRendererRect {
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsRendererRect
     */
    llx?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsRendererRect
     */
    lly?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsRendererRect
     */
    urx?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsRendererRect
     */
    ury?: number;
}

export function MelcoFusionModelsRendererRectFromJSON(json: any): MelcoFusionModelsRendererRect {
    return MelcoFusionModelsRendererRectFromJSONTyped(json, false);
}

export function MelcoFusionModelsRendererRectFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsRendererRect {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'llx': !exists(json, 'llx') ? undefined : json['llx'],
        'lly': !exists(json, 'lly') ? undefined : json['lly'],
        'urx': !exists(json, 'urx') ? undefined : json['urx'],
        'ury': !exists(json, 'ury') ? undefined : json['ury'],
    };
}

export function MelcoFusionModelsRendererRectToJSON(value?: MelcoFusionModelsRendererRect | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'llx': value.llx,
        'lly': value.lly,
        'urx': value.urx,
        'ury': value.ury,
    };
}


